import { Menu } from '@headlessui/react';
import React from 'react';
import { useIntl } from 'react-intl';

import { CARET_LARGE } from '@/components/switchback/Icon/assets';
import Icon from '@/components/switchback/Icon/IconComponent';
import Link from '@/components/switchback/Link/Link';

import css from './BlogMenu.module.css';

interface IMenuItem {
  label: string;
  link: string;
}

interface IMenuItems {
  label: string;
  menuItems: IMenuItem[];
}

export const BlogMenu = () => {
  const intl = useIntl();

  const menuData: IMenuItems[] = [
    {
      label: intl.formatMessage({ defaultMessage: 'Resources & guides', id: 'KXAMmA' }),
      menuItems: [
        {
          label: intl.formatMessage({ defaultMessage: 'Resources and guides', id: '5o+PKS' }),
          link: 'resources-guides',
        },
        {
          label: intl.formatMessage({ defaultMessage: 'How-to guides', id: 'VuwzZ7' }),
          link: 'category/how-to-guides',
        },
        {
          label: intl.formatMessage({ defaultMessage: 'RV lifestyle', id: '6Cp12g' }),
          link: 'category/rv-lifestyle',
        },
        {
          label: intl.formatMessage({ defaultMessage: 'News and events', id: '++ayNL' }),
          link: 'category/news-events',
        },
      ],
    },
    {
      label: intl.formatMessage({ defaultMessage: 'RV Owners', id: 'afvdaR' }),
      menuItems: [
        {
          label: intl.formatMessage({ defaultMessage: 'All host articles', id: 'TTWZJA' }),
          link: 'for-owners',
        },
        {
          label: intl.formatMessage({ defaultMessage: 'RV maintenance', id: 'HkrlCB' }),
          link: 'category/rv-maintenance',
        },
        {
          label: intl.formatMessage({ defaultMessage: 'Remodeling and DIY', id: 'hjWT+I' }),
          link: 'category/rv-remodeling-diy',
        },
        {
          label: intl.formatMessage({ defaultMessage: 'RV business tips', id: '5eQp51' }),
          link: 'category/rv-business-tips',
        },
        {
          label: intl.formatMessage({ defaultMessage: 'Host stories', id: 'qkwgbL' }),
          link: 'category/owner-stories',
        },
      ],
    },
    {
      label: intl.formatMessage({ defaultMessage: 'Travel inspiration', id: '0MMMr8' }),
      menuItems: [
        {
          label: intl.formatMessage({ defaultMessage: 'All guest articles', id: 'waoGfI' }),
          link: 'for-renters',
        },
        {
          label: intl.formatMessage({ defaultMessage: 'RV beginner tips', id: 'e9GSUz' }),
          link: 'category/rv-beginner-tips',
        },
        {
          label: intl.formatMessage({ defaultMessage: 'Trip planning', id: 'ZXgbGE' }),
          link: 'category/trip-planning',
        },
        {
          label: intl.formatMessage({ defaultMessage: 'RV travel hacks', id: 'lMJcx3' }),
          link: 'category/rv-travel-hacks',
        },
        {
          label: intl.formatMessage({ defaultMessage: 'RV parks and campgrounds', id: '62ClZl' }),
          link: 'category/rv-parks-campgrounds',
        },
        {
          label: intl.formatMessage({ defaultMessage: 'Guest stories', id: 'Sz27hD' }),
          link: 'category/outdoorsy-renters',
        },
      ],
    },
  ];
  return (
    <>
      <div className="flex flex-col items-center justify-center px-4 py-6 md:flex-row space-x-4 md:mx-auto md:space-x-6 md:max-w-xxl md:overflow-visible">
        {menuData.map((menu: IMenuItems, index: number) => {
          return (
            <div className="inline-block text-center md:relative" key={index}>
              <Menu>
                {({ open }) => (
                  <>
                    <Menu.Button className="inline-flex justify-center py-2 md:ml-2 highlight autoType600 leading-5 transition duration-150 ease-in-out rounded-md hover:text-gray-800 focus:outline-none focus:border-blue-300 focus:ring-blue">
                      <span>{menu.label}</span>
                    </Menu.Button>

                    <Menu.Items
                      static
                      className={`absolute left-0 w-screen mt-2 outline-none md:left-1/2 md:-translate-x-1/2 md:w-56 md:origin-top-right z-50 ${
                        open
                          ? 'opacity-100 scale-100 pointer-events-auto'
                          : 'opacity-0 scale-95 pointer-events-none'
                      }`}>
                      <div className="py-1 mx-2 bg-white border border-gray-100 shadow-lg rounded-md">
                        {menu.menuItems.map(item => {
                          return (
                            <Menu.Item key={item.label}>
                              {({ active }) => (
                                <Link legacy href={`/blog/${item.link}`}>
                                  <a
                                    className={`${
                                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                                    } flex justify-between w-full px-4 py-2 text-sm  leading-5 text-left hover:bg-gray-100`}>
                                    {item.label}
                                  </a>
                                </Link>
                              )}
                            </Menu.Item>
                          );
                        })}
                      </div>
                    </Menu.Items>
                    <Icon
                      width={16}
                      height={16}
                      className={`transform inline ml-2 ${open ? 'rotate-90' : css.caret}`}
                      name={CARET_LARGE}
                    />
                  </>
                )}
                {/*  */}
              </Menu>
            </div>
          );
        })}
      </div>
    </>
  );
};
